const requestIdleCallback = window.requestIdleCallback;
const cancelIdleCallback = window.cancelIdleCallback;
export const requestIdleCallbackPolyfilled = requestIdleCallback ??
    ((f) => {
        const startTime = Date.now();
        return window.setTimeout(() => {
            f({
                didTimeout: false,
                timeRemaining: () => Math.max(0, 50.0 - (Date.now() - startTime)),
            });
        }, 1);
    });
export const cancelIdleCallbackPolyfilled = cancelIdleCallback ?? ((id) => window.clearTimeout(id));
//# sourceMappingURL=idleCallback.js.map